import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the order-side LC-only field gate.
 *
 * A handful of order fields are LC/CSR-only per docs/Permission-analysis.md but
 * were read-only on the /pro + drawer order view until now (Port of Origin /
 * Discharge, DC, Dept). Opening them for editing must not open them to every
 * order-editor, so their ORDER editability is gated by this component (their
 * TEMPLATE editability is handled separately by the template-edit gate).
 */
export const ORDER_LC_FIELDS_COMPONENT_ID = 'order-lc-fields';

/**
 * Whether the current user may edit the order-side LC-only fields.
 *
 * Resolved from the admin-configured component permission (permissions-mode handle
 * on the field group's frame) crossed with the user's Azure AD groups. Ships
 * **defaultDisabled**: until an admin grants a group edit access on
 * `order-lc-fields`, these fields stay read-only on orders for everyone —
 * preserving today's behavior. Only used for the ORDER branch; templates use
 * useCanEditTemplateFields.
 */
export const useCanEditOrderLcFields = (): boolean =>
  useResolvedAccessLevel(ORDER_LC_FIELDS_COMPONENT_ID, false, true) >= 2;
